import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga' // TODO: UAが廃止されたら削除
import ReactGA4 from 'react-ga4'
import { Ga4TrackingCodes, TrackingCode } from 'config/ga'
import { getEnv } from './env'

const gaPageView = (page: string) => {
  ReactGA.pageview(page) // TODO: UAが廃止されたら削除
  ReactGA4.send({
    hitType: 'pageview',
    page,
  })
}

const env = getEnv()

function GAHistoryListener() {
  const location = useLocation()

  useEffect(() => {
    ReactGA.initialize(TrackingCode) // TODO: UAが廃止されたら削除
    ReactGA4.initialize(Ga4TrackingCodes[env])
  }, [])

  useEffect(() => {
    gaPageView(window.location.pathname)
  }, [location])

  return null
}

export default GAHistoryListener
